export enum ConnectionTypeEnum {
  PostgreSQL = 'PostgreSQL',
  MySQL = 'MySQL',
  // ClickHouse = 'ClickHouse',
  SnowFlake = 'SnowFlake',
  BigQuery = 'BigQuery',
  Databricks = 'Databricks',
  MotherDuck = 'MotherDuck',
  Presto = 'Presto',
  Trino = 'Trino',
  GoogleApi = 'GoogleApi',
  Api = 'Api'
}
